module.exports = __webpack_public_path__ + "img/left.5d0715fb.png";